import { render, staticRenderFns } from "./PART_LEGEND.vue?vue&type=template&id=7a8aef07&scoped=true&"
import script from "./PART_LEGEND.vue?vue&type=script&lang=js&"
export * from "./PART_LEGEND.vue?vue&type=script&lang=js&"
import style0 from "./PART_LEGEND.vue?vue&type=style&index=0&id=7a8aef07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8aef07",
  null
  
)

export default component.exports